import { Box } from "@material-ui/core";
import { useContext } from "react";
import MedicoTerceiroAttachmentDataComponent from "../../../components/materialui/MedicoTerceiro/MedicoTerceiroAttachmentDataComponent";
import { MedicoTerceiroContext } from "../../../../context/MedicoTerceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";

export default function MedicoTerceiroAttachmentDataStep() {

    const { state, dispatch, updateFile, deleteFile } = useContext(MedicoTerceiroContext);

    const onInputAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: { form, value: fieldAttachment, name, subType: "Insert", id: ""},
        });
        updateFile(name, form, fieldAttachment, formField);
    };

    const onDeleteAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        deleteFile(name, form, fieldAttachment, formField);
    };

    return (
        <div>
            <Steps.StepTitle text="Anexos" />

            <Box mt={2}>
                <MedicoTerceiroAttachmentDataComponent MedicoTerceiroAttachmentForm={state.AttachmentForm} onInputChange={onInputAttachmentChange} onDeleteFile={onDeleteAttachmentChange} />
            </Box>
        </div>
    );
}